import { useContext } from 'react';

import { IOptionContext, OptionContext } from '../components/contexts/OptionsContext';

export const useOptionContext = (): IOptionContext => {
  const context = useContext(OptionContext);

  if (!context) throw new Error('Esse compomente deve ser usado dentro de um <Option> componente.');

  return context;
};
